var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0_3710_3040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3710_3040",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3710_3040",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3710_3040",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE6ElEQVR4nO2bS4skRRDHS4UdH6AoykQ0Ll7mtH4DX8d1BEUEO7NhBfXq0dcqCrsq4j58oQg+QD34uHtY/AArfgLPPkDXVVEPq852BJMS3T3MbPd2T2ZXVFVUV/6gLs1UTMa/ov6ZkdldFBGEfnHV0OPd5PF19vgtOTxPDoeT6/zks9PDPt4lfxsTM7OH0L/1Gnb47ETMEHON/3b9mfDobVdnMSOgATxMDn6KFXhGcA8/0gAfivlfnSQUxRXk8Th53F5W5F2xcZscnAjHiiubzssUIgh5+LKswLN2Ap/LA2w6PzOQg1e1Rd7j3S81nZ8dT46wC/JwUSbIMDjYk4s9Hh19FmMjg457tqwuEia+o9P3y2exE2To8mokVii5wpGbcfr+0L8F4m0Eni66iDQYKevkeXESvPrXNq1CZAWmEmjo4J6USW1enJQYQ4d3Fi1hsmo6UToQOXyjbqHJ4amiJeyOuaTYsk9Rt9Ds4WzREi4tkBJik8ffNIQmD1spPl20hJmxL+vZMWvgKKEd3ksO/osS2sNW0RIuXyhLVHaq0KF/4w0LYt0XU9nUoNChf+gAeXiHHPyZZnclKztlaTe6HDyxKB47fN6ydZDDT8oIvLTYqZOhvAHkeg/Mizdpy01Ohux6j2uJnGwjcjKS/iTnix1876Da4BS5OFi/nTz8oy00OzgWNQA5flrutYEt8eTpeOzgxf3uHfreHUWNhEfWryOP36lXc4p1pLbg02Kzx+d2d/LgBTlH3Gdw5+puwcnjp42KvIOc8am/UnMveLISNZfwZXJ4QSxl4f1l7GIa2bqULcyqRSaH34fNjbXCjC+vP7ZfDDWRd5BNeY1zwgWv2jZ5fLAw4suyzIuJU9ouLgd5fKWyinYlK0HRl+UByIOIiVPJ+Mcn4PCFfjXDZ3UezoollPHlS2MpVvKM2A5fVvu6gcfjdYo88mWHF8r48l4qEXnWs5efIMnhD5qeHDY31qTRIYe/lBhTlC/XjqxG5IxP9iYSqvgcO3hKc3URNjfW2OGZkm9XtC83hjQYcvwkJyPs4BsRftSGS3c4eghwljyclI5PuxkJGiIn+nLnCP1DB9jDV+Un5DRf7hRBoZLHlgEfN52LWYKKJ8Mf5PBNeSuazqe9Ijs8o93KT05eTi5a1ZCDn0ffjm37wwsNiSyIgPGTa/376TVPfPB1Vd/dS1mfyxK2sEY4ctP15OBt8cxSE1tFlbxD6ngKS5DHwzrbr1BZJbda6HEV4wc6265QucitFFqvirE2kVsltG4VY60it0ZozSqm8Vr1tTqPvEwKHe7Ha8nje+Tx7+TfHXo8rD4epUbDnNDk8f30zX/4SKylkvEoNRqmhJ78DvHfpqt4L1KtKbZUrJLQkyr+sKoqrkIgU0LHWEcdVdwJoSe/SXyXPPw19Vr+Th7eqqOKOyG0NTgLnYVeKThXdLsaDV5VjyZjjcYKC40qJxpZ6H1gY5W4shXNxgTKQvssdK7oNsDGXvlsHb6jQq9qo8HWhF7VRoPtCb2ajQZbE9paYmwsjhrWEmNjcdSwlhgbi6OGtcTYWBw1rCXGxuKoYS0xNhZHDWuJsbE4alhLjI3FUcNaYmwsjhrWEmNjcdSwlhgbi6OGtcTYWBw1rCXGxuKoYS0xNhZHDWuJsbE4mUwmk8lkMplMJpPJZDJFB/gfciKPf3zO1Q8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.e4cc9683fea2746d2464c96e01da72d1.svg";
export { ForwardRef as ReactComponent };